import * as _ from 'underscore';
import { ContentLineageRelationshipInfo } from '../models/ContentLineageRelationshipInfo';
import { ContentLineageRelationship } from '../ServerApi/types/ContentLineageRelationship';
import { INamedItem } from '../ServerApi/types/resourceParts';

export module ContentLineageRelationshipMapper {

export function map(
  contentLineageRelationships: ReadonlyArray<ContentLineageRelationship>): ContentLineageRelationshipInfo[] {
    return _.map(contentLineageRelationships, (r: ContentLineageRelationship) => {
      return {
        content: { id: r.content.id, name: r.content.name },
        contentType: r.contentType,
        relatedContent: { id: r.relatedContent.id, name: r.relatedContent.name },
        relatedContentType: r.relatedContentType,
        lineageRelationshipType: r.lineageRelationshipType,
        permissionsAreRequired: r.permissionsAreRequired,
        linkedTasksAreNotEnabled: r.linkedTasksAreNotEnabled,
      };
    });
  }
}
